import { inject, Injectable } from '@angular/core';
import { BaseHttpService } from './base.http.service';
import { AddressBookEntry } from '../../shared/models/address-book.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AddressBookSearchService {

  baseHttpService = inject(BaseHttpService);

  searchAddressBook(searchString: string): Observable<AddressBookEntry[]> {
    return this.baseHttpService.get<AddressBookEntry[]>("/address-book-currency/" + searchString);
  }
}
